import { RAISE_API_V1_URL } from "constants/endpoints";
import { get, post } from "services/api";

export const checkout = async ({
  selectedPayment: payment_method_uuid,
  device
}) => {
  const body = {
    payment_method_uuid,
    device
  };

  return await post(`${RAISE_API_V1_URL}/checkout`, body);
};

export const getCheckoutData = async () => {
  const response = await get(`${RAISE_API_V1_URL}/checkout`);

  return response.data;
};

export const getDeviceIp = async () => {
  const URL = "https://api.ipify.org?format=json";
  const response = await get(URL);

  return response.data;
};

export const getPaymentMethods = async () => {
  const URL = `${RAISE_API_V1_URL}/payment_methods`;
  const response = await get(URL);

  return response.data;
};

export const savePaymentMethod = async ({ paymentMethod: body }) => {
  const URL = `${RAISE_API_V1_URL}/payment_methods`;
  const response = await post(URL, body);

  return response.data;
};
